define("calendar/models/ig-post", ["exports", "shared/models/ig-post"], function (_exports, _igPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "DynamoIgPost", {
    enumerable: true,
    get: function () {
      return _igPost.DynamoIgPost;
    }
  });
  Object.defineProperty(_exports, "default", {
    enumerable: true,
    get: function () {
      return _igPost.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"shared/models/ig-post",0,"shared/models/ig-post"eaimeta@70e063a35619d71f
});